import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withPulse?: boolean;
  children: React.ReactNode;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withPulse = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#FF6B6B] text-white hover:bg-[#E85D5D] hover:shadow-lg shadow-md border border-transparent focus:ring-[#FF6B6B]',
    secondary: 'bg-[#2C7A7B] text-white hover:bg-[#236C6D] shadow-md border border-transparent focus:ring-[#2C7A7B]',
    outline: 'bg-transparent border-2 border-[#2C7A7B] text-[#2C7A7B] hover:bg-[#2C7A7B]/10',
    ghost: 'bg-transparent text-[#2C7A7B] hover:bg-[#2C7A7B]/10 hover:text-[#236C6D]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl font-bold'
  };
  const pulseAnimation = withPulse ? {
    scale: [1, 1.02, 1],
    boxShadow: ['0 4px 6px -1px rgba(255, 107, 107, 0.1), 0 2px 4px -1px rgba(255, 107, 107, 0.06)', '0 10px 15px -3px rgba(255, 107, 107, 0.3), 0 4px 6px -2px rgba(255, 107, 107, 0.1)', '0 4px 6px -1px rgba(255, 107, 107, 0.1), 0 2px 4px -1px rgba(255, 107, 107, 0.06)'],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  } : {};
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button className={combinedClassName} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={pulseAnimation} {...props} data-id="element-359">
      {children}
    </motion.button>;
}